var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-table",
    {
      attrs: { data: _vm.companies, "row-class-name": "cpointer" },
      on: { "row-click": _vm.companySelected }
    },
    [
      _c("el-table-column", {
        attrs: { prop: "name", label: _vm.$t.__("common.labels.society_name") }
      }),
      _vm._v(" "),
      _c("el-table-column", {
        attrs: { prop: "companyType", label: _vm.$t.__("common.labels.type") }
      }),
      _vm._v(" "),
      _c("el-table-column", {
        attrs: {
          prop: "companyId",
          label: _vm.$t.__("companysearch.GB_results.company_id")
        }
      }),
      _vm._v(" "),
      _c("el-table-column", {
        attrs: { prop: "address", label: _vm.$t.__("common.labels.address") }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }